
export class GetCommonDetails {
  static readonly type = "Get Common";
  constructor() {}
}